import { render } from "./card-item.vue?vue&type=template&id=241236cb&scoped=true"
import script from "./card-item.vue?vue&type=script&lang=js"
export * from "./card-item.vue?vue&type=script&lang=js"

import "./card-item.vue?vue&type=style&index=0&id=241236cb&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241236cb"]])

export default __exports__